import React, { useEffect, useState } from "react";
import Markdown from 'react-markdown'
import { Button, Container, Divider, FormLabel, HStack, InputGroup, InputRightElement, Link, Table, Td, Text, Th, Tr, useToast, VStack } from "@chakra-ui/react"
import PageHeader from "./pagecomponents/PageHeader";
import { Input } from "@chakra-ui/react"
import { adminLogin, checkAdminLogin, internalProjectSearch, uploadInternalProject } from "../dashboardapi";
import { MdError, MdFileUpload, MdLogin, MdSearch } from "react-icons/md";
import Header from "../components/Header";
import { ExternalLinkIcon } from "@chakra-ui/icons";

const LoginAdmin = () => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const toast = useToast()

    const login = () => {
        adminLogin(username, password).then((res) => {
            if (res.data) {
                localStorage.setItem("adminToken", res.data.token);
            } else {
                toast({
                    title: "Login failed",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }

    return (
        <Container>
            <VStack gap="2" align={'start'} width="full">
                <FormLabel>User Name</FormLabel>
                <Input variant="outline" value={username} onChange={(e) => setUsername(e.target.value)} />
                <FormLabel>Password</FormLabel>
                <Input variant="outline" type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                <Button onClick={login}>Login</Button>
            </VStack>
        </Container>
    );
}


const ProjectUpload = () => {
    const [clientname, setclientname] = useState('EPL')
    const [projectFile, setprojectFile] = useState()
    const [projectLink, setprojectLink] = useState(null)
    const toast = useToast()

    const uploadProject = () => {
        uploadInternalProject(projectFile, clientname).then((res) => {
            if (res.data) {
                console.log(res.data.project_id)
                var link = `https://editlatex-dev.transforma.in/${res.data.project_id}?token=${res.data.token}`
                setprojectLink(link);
            } else {
                toast({
                    title: "Error uploading file",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }

    return (
        <Container>
            <VStack gap="2" align={'start'} width="full">
                <FormLabel>Upload project file (.tar.bz2)</FormLabel>
                <Input variant="outline" type="file" onChange={(e) => setprojectFile(e.target.files[0])} />
                <FormLabel>Client Name</FormLabel>
                <Input variant="outline" value={clientname} onChange={(e) => setclientname(e.target.value)} />
                <Button onClick={uploadProject}>Upload Project</Button>
                {projectLink ? <InputGroup size='md'>
                    <Input
                        pr='4.5rem'
                        type={'text'}
                        value={projectLink}
                    />
                    <InputRightElement width='4.5rem'>
                        <Button h='1.75rem' size='sm' onClick={() => { if (window.isSecureContext) { navigator.clipboard.writeText(projectLink) } }}>
                            Copy
                        </Button>
                    </InputRightElement>
                </InputGroup> : null}
            </VStack>
        </Container>
    );
}

const ProjectSearch = () => {
    const [searhTerm, setsearchTerm] = useState('epl')
    const [data, setdata] = useState(null)
    const toast = useToast()

    const searchProject = () => {
        setdata(null);
        internalProjectSearch(searhTerm).then((res) => {
            if (res.data) {
                setdata(res.data.data)
            } else {
                toast({
                    title: "Please enter valid search",
                    description: res.error.error,
                    status: "error",
                    duration: 2000,
                    isClosable: "true"
                })
            }
        })
    }

    const RenderTable = (props) => {
        const data = props.data;

        return (
            <Table>
                <Tr>
                    <Th>Sl. No.</Th>
                    <Th>Project Name</Th>
                    <Th>Created On</Th>
                    <Th>Internal Project</Th>
                    <Th>Link</Th>
                </Tr>
                {data.map((i, j) => (<Tr>
                    {console.log(i.is_internal)}
                    <Td>{j + 1}</Td>
                    <Td>{i.project_name}</Td>
                    <Td>{i.created_at}</Td>
                    <Th>{i.internal_project ? "Yes" : "No"}</Th>
                    <Td>{i.link ? <Link href={i.link} isExternal><ExternalLinkIcon mx='2px' /></Link> : <MdError mx='2px' />}</Td>
                </Tr>))}
            </Table>
        )
    }

    return (
        <VStack><InputGroup size='md'>
            <Input
                pr='4.5rem'
                type={'text'}
                value={searhTerm}
                onChange={(e) => setsearchTerm(e.target.value)}
            />
            <InputRightElement width='4.5rem'>
                <Button h='1.75rem' size='sm' onClick={searchProject}>
                    Search
                </Button>
            </InputRightElement>
        </InputGroup>
            {data ? <RenderTable data={data} /> : null}
        </VStack>
    )
}

const Admin = () => {
    const [isLoggedIn, setisLoggedIn] = useState(false);
    const [loginChecked, setloginChecked] = useState(false);
    const [selectedMenu, setselectedMenu] = useState(0);

    useEffect(() => {
        if (!isLoggedIn && !loginChecked) { checkLogin() };
    })

    const checkLogin = () => {
        checkAdminLogin().then((res) => {
            if (res.data) {
                console.log("Admin already logged in.")
                setisLoggedIn(true);
                setloginChecked(true);
            } else {
                setisLoggedIn(false)
            }
        })
    }

    return (
        <VStack>
            <HStack w={'100%'}>
                <VStack alignSelf={'flex-start'} w={'15%'} padding={5}>
                    <Button onClick={() => { setselectedMenu(0) }} width={'100%'} leftIcon={<MdLogin />} colorScheme='teal' variant='solid'>Login as Admin</Button>
                    <Button onClick={() => { setselectedMenu(1) }} width={'100%'} leftIcon={<MdFileUpload />} colorScheme='teal' variant='solid'>Upload Internal Project</Button>
                    <Button onClick={() => { setselectedMenu(2) }} width={'100%'} leftIcon={<MdSearch />} colorScheme='teal' variant='solid'>Search Internal Project</Button>
                </VStack>
                <Container padding={10}>
                    {selectedMenu === 0 && !isLoggedIn ? <LoginAdmin /> : <Text>Already logged in.</Text>}
                    {selectedMenu === 1 && isLoggedIn ? <ProjectUpload /> : null}
                    {selectedMenu === 2 && isLoggedIn ? <ProjectSearch /> : null}
                </Container>
            </HStack>
        </VStack>
    );
};

export default Admin;
